import { createApp } from 'vue'
import App from './App.vue'
import '@/assets/css/index.css'
import KProgress from 'k-progress-v3';

const app = createApp(App)
app.component('k-progress',KProgress).mount('#app')
